/* eslint-disable */
import React from 'react';

export const Banner30DataSource = {
    wrapper: {className: 'News_banner3'},
    textWrapper: {
        className: 'banner3-text-wrapper k0qetw54nvd-editor_css',
        children: [
            {
                name: 'nameEn',
                className: 'banner3-name-en k0qeu6wuncp-editor_css',
                children: (
                    <>
                        <p>NEWS &amp; EVENTS</p>
                    </>
                ),
            },
            {
                name: 'slogan',
                className: 'banner3-slogan k0qeu0atnj-editor_css',
                children: '新闻资讯',
                texty: true,
            },
        ],
    },
};
export const Content40DataSource = {
    wrapper: {className: 'home-page-wrapper content4-wrapper'},
    page: {className: 'home-page content4'},
    OverPack: {playScale: 0.3, className: ''},
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: (
                    <>
                        <p>视频资料 / Video&nbsp;</p>
                    </>
                ),
                className: 'title-h1',
            },
        ],
    },
    video: {
        className: 'content4-video',
        children: {
            video: 'img/video1.mp4',
            image: 'img/video1.jpg',
        },
    },
};
